<template>
  <dash-board-layout :active="1" :title="true">
    <toster />
    <div class="homepage mb-80">
      <div class="container">
        <div class="row">
          <div class="col-xl-8 col-lg-8">
            <div class="card">
              <div class="card-header border-0 pb-0">
                <h4 class="card-title">Recent Activities</h4>

                <router-link class="text-primary" :to="'/history'"
                  >View More
                </router-link>
              </div>
              <div class="card-body">
                <div class="transaction-table">
                  <div class="table-responsive">
                    <table class="table mb-0 table-responsive-sm">
                      <tbody>
                        <tr v-for="(item, index) in data" :key="index">
                          <td>
                            <span class="buy-thumb" v-if="item.value > 0"
                              ><i class="la la-arrow-up"></i
                            ></span>
                            <span class="sold-thumb" v-if="item.value < 0"
                              ><i class="la la-arrow-down"></i
                            ></span>
                          </td>
                          <td>
                            <span
                              :class="`badge badge-${
                                item.value > 0 ? 'success' : 'danger'
                              }`"
                              >{{ item.source }}</span
                            >
                          </td>
                          <td>
                            <i :class="`cc ${item.symbol}`"></i>
                            {{ item.symbol }}
                          </td>
                          <td>
                            <div
                              :title="item.orderNo"
                              style="
                                width: 150px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                              "
                            >
                              {{ item.orderNo }}
                            </div>
                          </td>
                          <td
                            :class="`text-${
                              item.value > 0 ? 'success' : 'danger'
                            }`"
                          >
                            <!-- {{ item.side == "BUY" ? "+" : "-"}} -->
                            {{ formatNumber(item.value, 8) }}
                            {{ item.display_name }}
                          </td>
                          <td>
                            {{ formatNumber(item.log_amount, 8) }}
                            {{ item.display_name }}
                          </td>
                        </tr>

                        <!-- <tr>
                          <td>
                            <span class="sold-thumb"
                              ><i class="la la-arrow-down"></i
                            ></span>
                          </td>

                          <td>
                            <span class="badge badge-danger">Sold</span>
                          </td>
                          <td><i class="cc BTC"></i> Bitcoin</td>
                          <td>Using - Bank *******5264</td>
                          <td class="text-danger">-0.000242 BTC</td>
                          <td>-0.125 USD</td>
                        </tr>
                        <tr>
                          <td>
                            <span class="buy-thumb"
                              ><i class="la la-arrow-up"></i
                            ></span>
                          </td>
                          <td>
                            <span class="badge badge-success">Buy</span>
                          </td>
                          <td><i class="cc LTC"></i> Litecoin</td>
                          <td>Using - Card *******8475</td>
                          <td class="text-success">-0.000242 BTC</td>
                          <td>-0.125 USD</td>
                        </tr>
                        <tr>
                          <td>
                            <span class="sold-thumb"
                              ><i class="la la-arrow-down"></i
                            ></span>
                          </td>
                          <td>
                            <span class="badge badge-danger">Sold</span>
                          </td>
                          <td><i class="cc XRP"></i> Ripple</td>
                          <td>Using - Card *******8475</td>
                          <td class="text-danger">-0.000242 BTC</td>
                          <td>-0.125 USD</td>
                        </tr>
                        <tr>
                          <td>
                            <span class="buy-thumb"
                              ><i class="la la-arrow-up"></i
                            ></span>
                          </td>
                          <td>
                            <span class="badge badge-success">Buy</span>
                          </td>
                          <td><i class="cc DASH"></i> Dash</td>
                          <td>Using - Card *******2321</td>
                          <td class="text-success">-0.000242 BTC</td>
                          <td>-0.125 USD</td>
                        </tr>
                        <tr>
                          <td>
                            <span class="sold-thumb"
                              ><i class="la la-arrow-down"></i
                            ></span>
                          </td>
                          <td>
                            <span class="badge badge-danger">Sold</span>
                          </td>
                          <td><i class="cc BTC"></i> Bitcoin</td>
                          <td>Using - Card *******2321</td>
                          <td class="text-danger">-0.000242 BTC</td>
                          <td>-0.125 USD</td>
                        </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="card profile_chart">
              <div class="card-header">
                <div class="chart_current_data">
                  <h3>{{ usdVal }} <span>USD</span></h3>
                </div>
                <div class="duration-option">
                  <a
                    id="all"
                    class="c-pointer"
                    @click="active = 'all'"
                    :class="active === 'all' && 'active'"
                    >ALL time</a
                  >
                  <a
                    id="one_month"
                    class="c-pointer"
                    @click="active = '1m'"
                    :class="active === '1m' && 'active'"
                    >24 H</a
                  >
                  <a
                    id="six_months"
                    class="c-pointer"
                    @click="active = '6m'"
                    :class="active === '6m' && 'active'"
                    >7D</a
                  >
                  <a
                    id="one_year"
                    class="c-pointer"
                    @click="active = '1y'"
                    :class="active === '1y' && 'active'"
                    >14D</a
                  >
                  <a
                    id="ytd"
                    class="c-pointer"
                    @click="active = 'ytm'"
                    :class="active === 'ytm' && 'active'"
                    >30D</a
                  >
                </div>
              </div>
              <div class="card-body pt-0">
                <timeline-chart />
              </div>
            </div> -->
          </div>
          <div class="col-xl-4 col-lg-4">
            <div class="card balance-widget">
              <div class="card-header pb-0 border-0">
                <h4 class="card-title">Your Portfolio</h4>
              </div>
              <div class="card-body pt-0">
                <div class="balance-widget">
                  <!-- <div class="total-balance">
                    <h3>${{ usdVal }}</h3>
                    <h6>Total Balance</h6>
                  </div> -->
                  <ul class="list-unstyled">
                    <li
                      class="media"
                      v-for="item in amountlist"
                      :key="item.symbol"
                    >
                      <!-- <i class="cc BTC mr-3"></i> -->
                      <i
                        :class="`cc ${item.symbol} mr-3`"
                        v-if="item.symbol != 'USD'"
                      ></i>
                      <i
                        :class="`fa fa-money mr-3`"
                        v-if="item.symbol == 'USD'"
                      ></i>
                      <div class="media-body">
                        <h5 class="m-0">{{ item.display_name }}</h5>
                      </div>
                      <div class="text-right">
                        <h5>
                          {{ formatNumber(parseFloat(item.available), 2) }}
                          {{ item.display_name }}
                        </h5>
                        <!-- <span v-if="item.symbol != 'USDT'"
                          >0.125 {{ item.symbol }}</span
                        > -->
                      </div>
                    </li>
                    <!-- <li class="media">
                      <i class="cc LTC mr-3"></i>
                      <div class="media-body">
                        <h5 class="m-0">Litecoin</h5>
                      </div>
                      <div class="text-right">
                        <h5>0.000242 LTC</h5>
                        <span>0.125 USD</span>
                      </div>
                    </li>
                    <li class="media">
                      <i class="cc XRP mr-3"></i>
                      <div class="media-body">
                        <h5 class="m-0">Ripple</h5>
                      </div>
                      <div class="text-right">
                        <h5>0.000242 XRP</h5>
                        <span>0.125 USD</span>
                      </div>
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 col-lg-12"></div>
          <!-- <div class="col-xl-3 col-lg-3">
            <div class="card apps-download">
              <div class="card-body">
                <h4 class="card-title">Mobile app</h4>
                <div class="apps-download-content">
                  <h3>
                    Get the best mobile app to exchange or buy crypto on the go:
                  </h3>
                  <div class="mt-4 text-center">
                    <a href="#" class="btn btn-primary my-1 ml-2"
                      ><img src="../../assets/images/android.svg" alt=""
                    /></a>
                    <a href="#" class="btn btn-success my-1 ml-2"
                      ><img src="../../assets/images/apple.svg" alt=""
                    /></a>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </dash-board-layout>
</template>
<script>
// import BtcChart from "../../components/cheerio/charts/BtcChart";
import { getFullNum, formatNumber } from "../../plugins/utils/operation";
import { amountlistinfo, coinPrice } from "../../plugins/api/amount";
// import TimelineChart from "../../components/cheerio/charts/TimelineChart.vue";
import { list } from "../../plugins/api/history";
import Toster from "../../components/cheerio/Toster.vue";
// import WalletChart from "../../components/cheerio/charts/WalletChart.vue";
// import CurrencyForm from "../../components/cheerio/form/CurrencyForm";
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
export default {
  components: {
    DashBoardLayout,
    // BtcChart,
    // TimelineChart,
    Toster,
    // WalletChart,
    // CurrencyForm,
  },
  data() {
    return {
      data: [],
      active: "all",
      amountlist: {},
      coinPriceList: {},
      allCalcAmount: "0",
      pager: {},
      page: 1,
      per_page: 10,
    };
  },
  computed: {
    usdVal: function () {
      return this.$store.state.usdVal;
    },
    btcVal: function () {
      return this.$store.state.btcVal;
    },
  },
  mounted() {
    this.getdata();
  },
  created() {
    coinPrice().then((res) => {
      this.coinPriceList = res;
    });
    amountlistinfo().then((res) => {
      this.amountlist = res.filter((item) => {
        return item.symbol.indexOf("_") < 0;
      });
    });
  },
  methods: {
    formatNumber(n1, n2, n3) {
      return formatNumber(n1, n2, n3);
    },
    getFullNum(n1, n2) {
      return getFullNum(n1, n2);
    },
    getdata() {
      list({ page: this.page, per_page: this.per_page }).then((res) => {
        if (res.code == 0) {
          this.data = res.data;
          this.pager = res.meta.pagination;
          this.curPage = 1;
        }
      });
    },
  },
};
</script>
